<template>
<div>
    <div v-if="isLoading" class="text-center">
        <div class="spinner-border">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    <div v-else>
        <nav v-if="availableSections.length > 1" class="section-tabs" aria-label="İçerik bölümleri">
          <button v-for="section in availableSections" :key="section.type" type="button" :aria-pressed="contentType === section.type" @click="GetContent(section.type)">{{ section.label }}</button>
        </nav>
        <div class="tab-content p-2">
            <div class="tab-pane fade show active" v-if="bookContent!=null">
                <SubjectBookImage v-if="bookContent.bookUrl" :url="bookContent.bookUrl" />
                <SubjectHtmlContent ref="htmlContent" v-if="bookContent.contentHtml != null" :book-content="bookContent"
                  :BookParentTitle="BookParentTitle" :BookSubTitle="BookSubTitle"
                  :language="contentLanguage" :external-language-control="externalLanguageControl" :has-translation="hasTranslation"
                  :ChangeLanguageButtonText="ChangeLanguageButtonText" :is-ready-audio-button="isReadyAudioButton" :active-dialog="activeDialog"
                  @change-language="selectLanguage" @play-audio="playAudio" />
            </div>
        </div>
        <audio ref="audio" preload="none" @ended="onAudioEnded"></audio>
    </div>
</div> 
</template>
<script>
import '../../../assets/styles/book-design.css';
import SubjectBookImage from './SubjectBookImage.vue';
import SubjectHtmlContent from './SubjectHtmlContent.vue';
 import { ErrorToast} from "@/common/notification.js";
  export default {
    name: "TabLearnSubject",
    components: { SubjectBookImage, SubjectHtmlContent },
    emits: ['language-availability', 'language'],
    props: {
      language: { type: String, default: 'en-EN' },
      externalLanguageControl: { type: Boolean, default: false },
      contents:{
        type:Array
      },
      bookTitle:{
        type: Object
      }
    },
    data() {
      return {
        contentType:0,
        contentLanguage:'en-EN',
        bookContent:null,
        isLoading:true,
        audioRequest: 0,
        activeDialog: null,
        isReadyAudioButton:false,

        isPlay:false
      }
    },
    computed: {
       availableSections() {
         return [{type:1,label:'Bölüm 1'},{type:2,label:'Bölüm 2'},{type:3,label:'Bölüm 3'},{type:6,label:'Bölüm 4'},{type:10,label:'Diyalog 1'},{type:11,label:'Diyalog 2'},{type:12,label:'Diyalog 3'}].filter(x => this.IsContent(x.type));
       },
       hasTranslation() {
         const source = this.contents?.find(x => x.contentType === (this.contentType || 13));
         if (![10, 11, 12, 13].includes(source?.contentType)) return false;
         return !!source?.languages?.some(x => x.languageCode === 'tr-TR' && (x.contentHtml?.trim() || x.dialogs?.length));
       },
       ChangeLanguageButtonText(){
            if(this.contentLanguage=='en-EN'){
                return 'Türkçe Göster <i class="bi bi-eye"></i>';
            }else{
                return 'Türkçe Gizle <i class="bi bi-eye-slash"></i>';
            }
       },
       BookParentTitle(){
        if(this.bookTitle){
            return this.bookTitle.bookParentTitle;
        }
        return '';
       },
       BookSubTitle(){
        if(this.bookTitle){
            return this.bookTitle.bookSubTitle;
        }
        return '';
       }
    },
    methods: {
        stopAudio() {
            this.$refs.htmlContent?.stop();
            this.$refs.audio?.pause();
            this.audioRequest++; this.activeDialog = null;
            this.isPlay = false;
        },
        applyLanguage() {
            const next = this.hasTranslation ? this.language : 'en-EN';
            if (this.contentLanguage === next) return;
            this.stopAudio();
            this.contentLanguage = next;
            if (this.contentType) this.GetContent(this.contentType);
        },

        IsContent(value){
            if(this.contents.length>0)
            {
                let find = this.contents.find(x=>x.contentType===value);
                if(find){
                    return true;
                }
            }
            return false;
        },
        GetContent(contentType){
            this.stopAudio();
            this.contentType = contentType;
            if (this.externalLanguageControl) this.contentLanguage = this.hasTranslation ? this.language : 'en-EN';
            let contentHtml = '',contentTitle='',contentHtmlTr = '',contentTitleTr='',contentImageUrl='';
            let contentDialogs=[],contentDialogsTr=[];
            let sectionImageUrl = null;
            if(this.contents.length){
                let findBookContent = this.contents.filter(x=>x.contentType==contentType)[0];
                if(findBookContent){
                    contentTitle = findBookContent.contentTitle;
                    const fileName = findBookContent.fileName?.trim();
                    contentImageUrl = fileName ? process.env.VUE_APP_ROOT_API+'Book/BookImage?fileName=' + encodeURIComponent(fileName) : null;
                    const sectionImageFileName = findBookContent.sectionImageFileName?.trim();
                    if ([10, 11, 12].includes(contentType) && sectionImageFileName) {
                        sectionImageUrl = process.env.VUE_APP_ROOT_API + 'Book/SectionImage?fileName=' + encodeURIComponent(sectionImageFileName);
                    }
                    contentHtml = findBookContent.contentHtml;
                    if(findBookContent.contentType==10 || findBookContent.contentType==11 || findBookContent.contentType==12){
                        if((findBookContent.dialogs || []).length>0){
                            for (let i = 0; i < (findBookContent.dialogs || []).length; i++) {
                                contentDialogs.push({name:findBookContent.dialogs[i].name.replace(':',''),content:findBookContent.dialogs[i].content,audio:findBookContent.dialogs[i].audioFile});
                            }
                        }
                        let findBookContentTr = (findBookContent.languages || []).filter(x=>x.languageCode=='tr-TR');
                        if(findBookContentTr && findBookContentTr.length>0){
                            contentTitleTr = findBookContentTr[0].contentTitle;
                            contentHtmlTr = findBookContentTr[0].contentHtml;
                            if((findBookContentTr[0].dialogs || []).length>0){
                                for (let i = 0; i < (findBookContentTr[0].dialogs || []).length; i++) {
                                    contentDialogsTr.push({name:findBookContentTr[0].dialogs[i].name.replace(':',''),content:findBookContentTr[0].dialogs[i].content,audio:''});
                                }
                            }
                        }
                    }
                }
            }

            this.bookContent = {
                bookUrl: contentImageUrl,
                sectionImageUrl,
                contentHtml : this.contentLanguage=='en-EN'?contentHtml:contentHtmlTr,
                contentTitle: this.contentLanguage=='en-EN'?contentTitle:contentTitleTr,
                contentDialogs: this.contentLanguage=='en-EN'?contentDialogs:contentDialogsTr,
            };

        },
        selectLanguage(language) {
            if (this.externalLanguageControl) { this.$emit('language', language); return; }
            if (language !== this.contentLanguage) this.ChangeLanguage();
        },
        ChangeLanguage(){
            this.contentLanguage = this.contentLanguage == 'en-EN'?'tr-TR':'en-EN';
            this.GetContent(this.contentType)
        },

        async playAudio(value, index) {
            if (this.activeDialog === index) { this.stopAudio(); return; }
            this.stopAudio();
            const player = this.$refs.audio;
            if (!player || !value) return;
            const request = this.audioRequest;
            this.activeDialog = index;
            player.src = process.env.VUE_APP_ROOT_API + 'Source/dictionary/bookdialogaudio?fileName=' + encodeURIComponent(value);
            try {
                await player.play();
                if (request === this.audioRequest) this.isPlay = true;
            } catch (error) {
                if (request !== this.audioRequest || error?.name === 'AbortError') return;
                this.stopAudio();
                ErrorToast('Ses dosyası oynatılamadı. Lütfen yeniden deneyin.');
            }
        },
        onAudioEnded() { this.stopAudio(); }
    },
    mounted() {

        this.isReadyAudioButton = true;
    },
    beforeUnmount() {
        this.stopAudio();

    },
    watch:{
        hasTranslation: { immediate: true, handler(value) {
          this.$emit('language-availability', value);
          this.applyLanguage();
        } },
        language() { this.applyLanguage(); },
        contents: { immediate: true, handler(value) {
            if (!value) return;
            this.isLoading = false;
            const first = this.availableSections.find(x => x.type === this.contentType) || this.availableSections[0];
            if (first) this.GetContent(first.type);
            else this.bookContent = null;
        } },
    }
  };
  </script>

<style scoped>
.section-tabs { display: flex; gap: 8px; overflow-x: auto; padding: 4px 2px 12px; margin-bottom: 12px; }
.section-tabs button { flex-shrink: 0; border: 1px solid #e2e8f0; border-radius: 10px; padding: 10px 16px; background: white; color: #526174; }
.section-tabs button[aria-pressed="true"] { color: var(--brand-primary-hover); border-color: #a7f3d0; background: #ecfdf5; font-weight: 600; }
.section-tabs button:focus-visible { outline: 3px solid var(--brand-primary); outline-offset: 1px; }

</style>
